import { type VariantProps, cva } from "class-variance-authority";
import { type HTMLAttributes, forwardRef } from "react";
import { cn } from "../lib/cn";

export const spinnerVariants = cva(
	"animate-spin rounded-full border-2 border-current border-t-transparent",
	{
		variants: {
			size: {
				sm: "h-4 w-4",
				default: "h-6 w-6",
				lg: "h-8 w-8",
			},
		},
		defaultVariants: {
			size: "default",
		},
	},
);

export interface SpinnerProps
	extends HTMLAttributes<HTMLSpanElement>,
		VariantProps<typeof spinnerVariants> {
	label?: string;
}

const Spinner = forwardRef<HTMLSpanElement, SpinnerProps>(
	({ className, size, label = "Loading...", ...props }, ref) => (
		<span
			ref={ref}
			role="status"
			aria-label={label}
			className={cn("inline-flex", className)}
			{...props}
		>
			<span className={cn(spinnerVariants({ size }))} aria-hidden="true" />
			<span className="sr-only">{label}</span>
		</span>
	),
);
Spinner.displayName = "Spinner";

export default Spinner;
export { Spinner };
